import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onDone }) => {
  const [leaving, setLeaving] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 2400);
    const t2 = setTimeout(() => { setHidden(true); onDone?.(); }, 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  if (hidden) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        background: 'radial-gradient(circle at 50% 50%, #1B0A38 0%, #0A0417 60%, #050110 100%)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
        opacity: leaving ? 0 : 1,
        pointerEvents: leaving ? 'none' : 'auto',
      }}
    >
      {/* Ambient blobs */}
      <div className="glow-ring animate-blob" style={{ width: 500, height: 500, background: '#8247E5', top: '20%', left: '20%' }} />
      <div className="glow-ring animate-blob" style={{ width: 400, height: 400, background: '#A855F7', bottom: '15%', right: '15%', animationDelay: '3s' }} />

      <div className="relative flex flex-col items-center">
        {/* Logo mark with rotating ring */}
        <div className="relative w-24 h-24 mb-8" style={{ animation: 'splash-logo 0.9s cubic-bezier(0.22, 1, 0.36, 1) forwards' }}>
          <div className="absolute inset-0 rounded-2xl" style={{
            background: 'linear-gradient(135deg, #8247E5, #A855F7)',
            boxShadow: '0 20px 60px rgba(130,71,229,0.6), 0 0 0 1px rgba(255,255,255,0.1) inset'
          }} />
          <div className="absolute inset-[-8px] rounded-2xl border border-white/20" style={{ animation: 'ring-spin 4s linear infinite' }} />
          <div className="absolute inset-0 flex items-center justify-center">
            <svg viewBox="0 0 40 40" className="w-12 h-12" fill="none">
              <path d="M12 8 L20 4 L28 8 L28 16 L20 20 L12 16 Z" fill="white" opacity="0.95" />
              <path d="M12 24 L20 20 L28 24 L28 32 L20 36 L12 32 Z" fill="white" opacity="0.7" />
            </svg>
          </div>
        </div>

        {/* Letters */}
        <div className="flex items-center font-display font-bold text-white text-5xl md:text-6xl tracking-tight">
          {'TokenGate'.split('').map((ch, i) => (
            <span key={i}
              style={{
                display: 'inline-block',
                opacity: 0,
                animation: `splash-letter 0.7s ${0.2 + i * 0.07}s cubic-bezier(0.22, 1, 0.36, 1) forwards`,
                background: 'linear-gradient(180deg, #ffffff 0%, #C084FC 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {ch}
            </span>
          ))}
        </div>

        {/* Tagline */}
        <div className="mt-3 text-sm md:text-base text-white/60 tracking-[0.3em] uppercase"
          style={{ animation: 'splash-tagline 0.8s 1.2s ease forwards', opacity: 0 }}>
          The gateway to your crypto life
        </div>

        {/* Loader bar */}
        <div className="mt-10 w-56 h-[3px] bg-white/10 rounded-full overflow-hidden">
          <div className="h-full rounded-full"
            style={{
              background: 'linear-gradient(90deg, #8247E5, #C084FC)',
              animation: 'splash-bar 2.2s cubic-bezier(0.4, 0, 0.2, 1) forwards'
            }} />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
